import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { FlagIcon } from 'components/common/FlagIcon/FlagIcon';
import { Accordion } from 'components/no-auth/common/accordion/Accordion';
import styles from 'components/no-auth/common/accordion/Accordion.module.css';
import { PromoDangerouslyHtml } from 'components/no-auth/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { CommonSection, TextComponent } from 'components/no-auth/common/sections/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toLowerCase } from 'helpers/utils';

const SupportedCountriesPage = (props) => {
    const getItems = () => {
        return props.countriesList.map((c) => {
            return {
                header: (
                    <div className={styles.accordionHeaderContent}>
                        {c.code_a2 && (
                            <div className={styles.accordionFlag}>
                                <FlagIcon name={`${toLowerCase(c.code_a2)}`} size={'24px'} />
                            </div>
                        )}
                        {c.name && (
                            <PromoText color={'baseColor'} tag={'span'}>
                                {c.name}
                            </PromoText>
                        )}
                    </div>
                ),
                content: (
                    <TextComponent>
                        <PromoDangerouslyHtml dangerouslyHtml={c.services_info} tag="div" color="baseColor" />
                    </TextComponent>
                ),
            };
        });
    };

    return (
        <PromoPageContainer bgColor="eggshell03" hasTopPadding>
            <PromoSectionContainer>
                {props.helpSectionName && <HeadingSection title={props.helpSectionName} text={props.helpSectionText} titleTag={'h1'} />}
                {Array.isArray(props.countriesList) && (
                    <CommonSection>
                        <Accordion items={getItems()} />
                    </CommonSection>
                )}
            </PromoSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        helpSectionName: state.extra?.strapiApi?.[0]?.title,
        helpSectionText: state.extra?.strapiApi?.[0]?.text,
        countriesList: state.extra?.strapiApi?.[0]?.countries,
    };
};
SupportedCountriesPage.propTypes = {
    helpSectionName: PropTypes.string,
    helpSectionText: PropTypes.string,
    countriesList: PropTypes.array,
};

export default connect(mapStateToProps)(NotAuthBasePage(SupportedCountriesPage));
